import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../utils/api';
import { AdminSidebar } from '../../components/AdminSidebar';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

export const AdminSettings = () => {
  const { token } = useAuth();
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPolicies();
  }, []);

  const loadPolicies = async () => {
    try {
      const data = await api.get('/api/admin/policies', token);
      setPolicies(data);
    } catch (error) {
      toast.error('Erro ao carregar políticas');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (policy) => {
    try {
      await api.put(`/api/admin/policies/${policy.id}`, policy, token);
      toast.success('Política atualizada!');
    } catch (error) {
      toast.error('Erro ao atualizar política');
    }
  };

  return (
    <div className="flex min-h-screen bg-background" data-testid="admin-settings-page">
      <AdminSidebar />
      
      <div className="flex-1 p-8">
        <h1 className="text-4xl font-display font-bold text-primary mb-8">
          Configurações
        </h1>

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : (
          <div className="space-y-6 max-w-3xl">
            {policies.map((policy) => (
              <div key={policy.id} className="bg-white p-6 rounded-xl shadow-lg" data-testid={`policy-setting-${policy.type}`}>
                <h3 className="text-lg font-semibold text-primary mb-3 capitalize">
                  {policy.type === 'cancellation' ? 'Cancelamento' :
                   policy.type === 'checkin' ? 'Check-in' :
                   policy.type === 'checkout' ? 'Check-out' :
                   policy.type === 'privacy' ? 'Privacidade' :
                   policy.type === 'terms' ? 'Termos' : policy.type}
                </h3>
                <div className="space-y-3">
                  <div>
                    <Label>Descrição</Label>
                    <textarea
                      rows="3"
                      className="w-full rounded-lg border border-input bg-background px-3 py-2 text-sm"
                      value={policy.description}
                      onChange={(e) => {
                        const updated = policies.map(p =>
                          p.id === policy.id ? { ...p, description: e.target.value } : p
                        );
                        setPolicies(updated);
                      }}
                    />
                  </div>
                  {policy.value !== null && (
                    <div>
                      <Label>Valor</Label>
                      <Input
                        value={policy.value || ''}
                        onChange={(e) => {
                          const updated = policies.map(p =>
                            p.id === policy.id ? { ...p, value: e.target.value } : p
                          );
                          setPolicies(updated);
                        }}
                      />
                    </div>
                  )}
                  <Button onClick={() => handleUpdate(policy)} size="sm">
                    Salvar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
